<style lang="scss">



@media screen and (min-width: 55rem) {
  .aboutoverview-container {
    margin-top: 5rem;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    height: 35rem;
    .aboutoverview {
      width: 80%;
      max-width: 1080px;
      display: flex;
      flex-direction: row;
      justify-content: center;

      .aboutoverview-img {
        width: 40%;
        height: 90%;
        background-image: url("/media/yintai/about-1.png");
        background-size: cover;
      }
      .aboutoverview-text {
        width: 40%;
        height: 60%;
        margin-top: 5%;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        margin-left: 3rem;
        .aboutoverview-tip {
          font-size: 1rem;
          font-family:  'PingFang SC','Microsoft YaHei';
          font-weight: 500;
          color: #e5004f;
          line-height: 28px;
          text-transform: uppercase;
        }
        .aboutoverview-line {
          height: 0.1rem;
          width: 15rem;
          border-top: solid #e5004f 0.2rem;
          margin-top: 1rem;
          margin-left: -6rem;
        }
        .aboutoverview-title {
          font-size: 2rem;
          font-family:  'PingFang SC','Microsoft YaHei';
          font-weight: 400;
          color: #333333;
        }
        .aboutoverview-line2 {
          width: 2rem;
          height: 0.2rem;
          margin-top: 1rem;
          margin-bottom: 1rem;
          background-color: #e5004f;
        }
        .aboutoverview-introduction {

          text-align:justify;text-justify:auto;
          font-size: 1.1rem;
          font-family:  'PingFang SC','Microsoft YaHei';
          font-weight: 400;
          color: #7f7f7f;
          line-height: 1.6rem;
        }
      }
    }
  }
}
@media screen and (max-width: 55rem) {
  .aboutoverview-container {
    margin-top: 2rem;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    .aboutoverview {
      width: 80%;
      max-width: 1080px;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;

      .aboutoverview-img {
        width: 100%;
        height: 30rem;
        background-image: url("/media/yintai/about-1.png");
        background-size: cover;
      }
      .aboutoverview-text {
        width: 100%;
        margin-top: 2rem;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        .aboutoverview-tip {
          font-size: 1rem;
          font-family:  'PingFang SC','Microsoft YaHei';
          font-weight: 500;
          color: #e5004f;
          line-height: 28px;
          text-transform: uppercase;
        }
        .aboutoverview-line {
          height: 0.1rem;
          width: 15rem;
          border-top: solid #e5004f 0.2rem;
          margin-top: 0.6rem;
          margin-bottom: 0.4rem;
        }
        .aboutoverview-title {
          font-size: 2rem;
          font-family:  'PingFang SC','Microsoft YaHei';
          font-weight: 400;
          color: #333333;
        }
        .aboutoverview-line2 {
          width: 2rem;
          height: 0.2rem;
          margin-top: 1rem;
          margin-bottom: 1rem;
          background-color: #e5004f;
        }
        .aboutoverview-introduction {
          text-align: left;
          font-size: 1.1rem;
          font-family:  'PingFang SC','Microsoft YaHei';
          font-weight: 400;
          color: #7f7f7f;
          line-height: 1.4rem;
        }
      }
    }
  }
}
</style>

<template>
  <div class="aboutoverview-container">
    <div class="aboutoverview">
      <div class="aboutoverview-img"></div>
      <div class="aboutoverview-text">
        <div class="aboutoverview-tip">Intime Overview</div>
        <div class="aboutoverview-line"></div>
        <div class="aboutoverview-title">银泰百货</div>
        <div class="aboutoverview-line2"></div>
        <div class="aboutoverview-introduction">
          银泰商业（集团）有限公司成立于1998年。银泰百货为该集团旗下核心商业品牌，目前在全国范围内运营超60家商场，营业面积、经营业绩和业务创新能力皆位居中国零售业前茅。2018年以来，通过持续不断的数智化升级，银泰百货成为一家全面架构在云上、线上线下高度融合的数字百货公司，以创新业态、数字化服务与社会责任实践，持续引领时尚消费与商业发展新趋势。<br />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "aboutoverview",
  components: {},
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>
